export var RankedModeId = /*#__PURE__*/ function(RankedModeId) {
    RankedModeId["Classic4P"] = "Classic4P";
    RankedModeId["Classic1v1"] = "Classic1v1";
    RankedModeId["CitiesAndKnights4P"] = "CitiesAndKnights4P";
    RankedModeId["Rush4P"] = "Rush4P";
    return RankedModeId;
}({});
